import React, { useEffect, useState } from 'react'
import Button from '../SelectValue/Button'
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import TopDCom from './TopDCom';
import Chart from './Chart';
import getServices from '../../Services/get-service';
import swal from 'sweetalert';
import Loading from '../SelectValue/Loading';
import DatePicker from 'react-datepicker';
import avatar from '../../Assets/images/avatar.png'
import Investment from '../../Assets/images/Investment.png'
import database from '../../Assets/images/database.png'
import bag from '../../Assets/images/bag.png'
import inflow from '../../Assets/images/inflow.png'
import outflow from '../../Assets/images/outflow.png'
import Constants from '../../Constant';



function Overview() {
  const currentDate = new Date();
  const [totalInvestAv, setTotalInvestAv] = useState('0')
  const [totalUnitAva, setTotalUnitAva] = useState('0')
  const [tAmountSave, setTAmountSave] = useState('0')
  const [tAmountWithdraw, setTAmountWithdraw] = useState('0')
  const [proSold, setPropSold] = useState('0')
  const [propListed, setProListed] = useState('0')
  const [activeProject, setActiveProject] = useState('0')
  const [completedProject, setCompletedProject] = useState('0')
  const [investors, setInvestors] = useState('0')
  const [patners, setPatners] = useState('0')
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const twoWeekAgo = new Date(currentDate.getTime() - 14 * 24 * 60 * 60 * 1000);
  const [click, setClick] = useState(false)
  const [fromDate, setFromDate] = useState(oneWeekAgo);
  const [toDate, setToDate] = useState(currentDate);
  const [loading, setLoading] = useState(false)

  const [countData, setCountData] = useState([])

  const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  };


  // useEffect(()=>{

  //   const getAllCount = async ()=>{


  //   const response = await getServices.getAllCount()

  //   console.log('my count response ', response)

  //   if(response.data.status == 2000){
  //     setCountData(response.data.data)
  //   }

  //   }

  //   getAllCount()




  // })

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getServices.getAllCount(
          new Date().toISOString().split('T')[0],
          new Date().toISOString().split('T')[0]
        );
        if (response.data.status === '2000') {
          console.log("Count Data:", response.data.data);
          setCountData(response.data.data);
        } else {
          console.log("Something went wrong:", response.data.description);
        }
      } catch (error) {
        console.log("Error getting data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // useEffect(() =>{
  //     const newTodate= toDate.toISOString()
  //     const newFromdate= fromDate.toISOString()

  //     setLoading(true)
  //       getServices.getDashboardCount(newFromdate, newTodate).then(
  //         (response) => {
  //           setLoading(false)
  //         if(response.data.status === "2000"){
  //          setTotalInvestAv(response.data.data.totalSumActiveInvestment)
  //          setTotalUnitAva(response.data.data.totalSumCompletedInvestment)
  //          setTAmountSave(response.data.data.totalSumCompletedInvestment)
  //          setTAmountWithdraw(response.data.data.totalwithdrawalAmount)
  //          setProListed(response.data.data.totalSumListedProperty)
  //          setPropSold(response.data.data.totalSumpropertySold)
  //          setActiveProject(response.data.data.totalSumActiveProject)
  //          setCompletedProject(response.data.data.totalPendingProject)
  //          //setInvestors()
  //         }else{
  //          swal(response.data.description)
  //         //  toast('Session Expired', {
  //         //   onClose: () => {
  //         //       window.location.href = '/'
  //         //   },
  //         //   autoClose: 5000
  //         // })
  //         }

  //         console.log(response.data.data)

  //       },
  //       (error) => {
  //           setLoading(false)
  //           // toast('Session Expired', {
  //           //     onClose: () => {
  //           //       window.location.href = '/'
  //           //     },
  //           //     autoClose: 5000
  //           //   })
  //       }
  //       )
  //   },[fromDate, toDate])


  return (
    <div className="p-2 sm:p-4">
      <div>

        <Loading
          open={loading}
        />

        <div className=' mb-5 grid grid-cols-2 md:grid-cols-8 gap-4'>
          <div className=' pt-2 col-span-3'>
            <p className=' text-[20px] text-black font-normal'>Overview</p>
          </div>
          <div className=' pt-2'>
            <button onClick={() => {
              setFromDate(oneWeekAgo)
              setClick(false)
            }}
              className={!click ? ' font-normal text-[14px] inline-block text-back-color2 border-b-2 border-primary-color pb-2 text-center' : 'font-normal text-[14px] inline-block text-back-color2  pb-2 text-center'}>Last 7 days</button>
          </div>
          <div className=' pt-2'>
            <button onClick={() => {
              setFromDate(twoWeekAgo)
              setClick(true)
            }}
              className={click ? ' font-normal text-[14px] inline-block text-back-color2 border-b-2 border-primary-color pb-2 text-center' : 'font-normal text-[14px] inline-block text-back-color2  pb-2 text-center'}>Last 14 days</button>
          </div>
          <div className=' pt-2 flex gap-2'>
            <p className=' mb-2 pt-1'> From:</p>
            <DatePicker
              className=' w-full p-1 bg-white border-b border-gray-300 outline-0 rounded-lg'
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
          <div className=' pt-2 flex gap-2'>
            <p className=' mb-2 pt-1'>To:</p>
            <DatePicker
              className=' w-full p-1 bg-white border-b border-gray-300 outline-0 rounded-lg'
              selected={toDate}
              onChange={(date) => setToDate(date).toISOString()}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
          <div>
            <Button
              name='Search'
            />
          </div>
        </div>



        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 my-5">
          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={avatar} className="w-6 h-6" alt="avatar" />
            <p className="text-sm font-semibold text-gray-600">Total customers</p>
            <p className="text-sm font-semibold text-gray-900">
              {parseInt(countData.activeUsers ?? 0) + parseInt(countData.nonActiveUsers ?? 0) ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={Investment} className="w-6 h-6" alt="investment" />
            <p className="text-sm font-semibold text-gray-600">Active investments</p>
            <p className="text-sm font-semibold text-gray-900">
              {countData.activeInvsetmentPlan ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={database} className="w-6 h-6" alt="database" />
            <p className="text-sm font-semibold text-gray-600">Active savings plan</p>
            <p className="text-sm font-semibold text-gray-900">
              {countData.activeSavingsPlan ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={bag} className="w-6 h-6" alt="bag" />
            <p className="text-sm font-semibold text-gray-600">Total assets</p>
            <p className="text-sm font-semibold text-gray-900">
              {countData.totalAssets}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={inflow} className="w-6 h-6" alt="inflow" />
            <p className="text-sm font-semibold text-gray-600">Total inflow</p>
            <p className="text-sm font-semibold text-gray-900">
              NGN {Constants.FormatNumber(countData.totalInflow ?? 0)}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <img src={outflow} className="w-6 h-6" alt="outflow" />
            <p className="text-sm font-semibold text-gray-600">Total outflow</p>
            <p className="text-sm font-semibold text-gray-900">
              NGN {Constants.FormatNumber(countData.totalOutflow ?? 0)}
            </p>
          </div>
        </div>




        <Chart />




      </div>
    </div>
  )

}

export default Overview